import { render, staticRenderFns } from "./aggregator.vue?vue&type=template&id=65c4047b&scoped=true"
import script from "./aggregator.vue?vue&type=script&lang=js"
export * from "./aggregator.vue?vue&type=script&lang=js"
import style0 from "./aggregator.vue?vue&type=style&index=0&id=65c4047b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4047b",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/games/aggregator.vue
// module id = cZjx
// module chunks = 0